import React from 'react'
import { useSelector } from 'react-redux'
import { createNewUser, updateUser, removeUser } from '../store/actions'
import { getUsers } from '../store/selectors'

import BaseData from './BaseData';

export default () => {
    const users = useSelector(getUsers)

    const userEditFields = [
        {description: 'Vorname', name: 'firstName'},
        {description: 'Nachname', name: 'lastName'},
        {description: 'Loginname', name: 'loginname'},
        {description: 'Email', name: 'email'},
        {description: 'Admin', name: 'isApplicationOwner'}
    ]

    return (
        <BaseData 
            entities={users} 
            createAction={createNewUser} 
            updateAction={updateUser} 
            deleteAction={removeUser} 
            fieldDescription={userEditFields}
        />
    )
}




// WEBPACK FOOTER //
// ./src/pages/Users.js